
<script>
import Vue from 'vue';
import Layout from "@/components/layout/LayoutScreen.vue";
import CustomInput from "@/components/common/customInput.vue";
import { getAllUser, createUser, changeUserPassword, changeUserStatus} from '@/services/users-api';
import UsersTable from '@/components/tables/UsersTable.vue';

export default {
  name: "UsersScreen",
  components: { Layout, CustomInput, UsersTable },

  data() {
    return {
      permissionsOptions:[],
      username:null,
      userListIsBusy:false,
      selectedPermissions:null,
      mainPageModel:{page:1, pageSize:10},
      userList:[],

      showAddUserModal: false,
      showChangePasswordModal: false,
      user:{},
      editMode: false,
    };
  },
  created() {
  },

  mounted(){
    this.fetchUsers();
  },

  methods: {

    savePassword(){
      this.changeUserPassword()
    },

    onSelectedRow(row) {
      this.addNewUser(row)
    },

    addNewUser(user){

      this.user = {},
      this.editMode = false;

      if(user){
        this.user = user,
        this.editMode = true;
      }

      this.showAddUserModal= true
    },


    onchangePassword(user){
      this.user = user,
      this.showChangePasswordModal= true
    },
    
    onPageChange(newPage) {
      this.mainPageModel.page = newPage;
      this.fetchUsers();
    },

    onPageSizeChange(newPageSize) {
      this.mainPageModel.pageSize = newPageSize;
      this.mainPageModel.page = 1;
      this.fetchUsers();
    },


    //START API

    async onUpdatedRow(item){
      const userStatus = {
        isActive: item.isActive,
        isAdmin: item.isAdmin,
        page: this.mainPageModel.page,
        pageSize: this.mainPageModel.pageSize
      };

      console.log("userStatus:", userStatus)

      const result = await changeUserStatus(item.id, userStatus)

      this.userList = result.content || [];
      this.userListIsBusy= false
      this.mainPageModel.total = result.totalElements;
      this.mainPageModel.totalPages = result.totalPages;
      this.mainPageModel.page = result.pageNumber;

    },

    async changeUserPassword() {
      if (!this.user.newPassword || !this.user.confirmPassword) {
        Vue.prototype.$snotify.error("Veuillez entrer et confirmer le nouveau mot de passe.");
        return;
      }

      if (this.user.newPassword !== this.user.confirmPassword) {
        Vue.prototype.$snotify.error("Les mots de passe ne correspondent pas.");
        return;
      }

      const changePw = {
        userId: this.user.id,
        newPassword: this.user.newPassword
      };

      try {
        await changeUserPassword(changePw);
        Vue.prototype.$snotify.success("Mot de passe modifié avec succès !");

        this.user.newPassword = '';
        this.user.confirmPassword = '';
      } catch (error) {
        Vue.prototype.$snotify.error("Échec de la modification du mot de passe.");
      } finally {
        this.showChangePasswordModal= true
      }
    },

    async saveNewUser(){
      const params = {
        page: this.mainPageModel.page,
        pageSize: this.mainPageModel.pageSize
      };
      
      try {
        const result = await createUser(this.user, params)

        this.userList = result.content || [];
        this.userListIsBusy= false
        this.mainPageModel.total = result.totalElements;
        this.mainPageModel.totalPages = result.totalPages;
        this.mainPageModel.page = result.pageNumber;
      }  finally {
        this.showAddUserModal= true
      }

    },

    async fetchUsers() {
      this.userListIsBusy= true
        const params = {
          page: this.mainPageModel.page,
          pageSize: this.mainPageModel.pageSize,
        };

        if (this.username) params.name = this.username;
        if (this.selectedPermissions) params.permission = this.selectedPermissions.code;

        const result = await getAllUser(params);

        this.userList = result.content || [];
        this.userListIsBusy= false
        this.mainPageModel.total = result.totalElements;
        this.mainPageModel.totalPages = result.totalPages;
        this.mainPageModel.page = result.pageNumber;

    }

    //END API
  },

};
</script>

<template>
  <Layout>
    <div class="my-4">

      <div fluid class="d-flex justify-content-center align-items-center mt-5">
      <div class="custom-card-description shadow-lg text-center p-4 rounded-lg w-100">
        <h1 class="font-weight-bold text-primary mb-3 text-uppercase" style="font-size: 20px;">
          PARAMÈTRES DES Clients
        </h1>
        <p class="text-muted" style="font-size: 14px;">
          Configurez ici les paramètres relatifs aux comptes clients,
        </p>
      </div>
    </div>



    <div class="custom-card-description shadow-lg text-center px-md-4 px-1 py-4 rounded-lg w-100 row mb-5 mt-5">
      <div class="col-12">
          <div class="row mb-3">
            <div class="col-12">
              <h5 class="text-uppercase text-primary text-left" >List Des Utilisateurs </h5>
            </div>

          </div>
          <div class="row text-left">
            <div class="col-md-4 mb-2">

              <CustomInput class="w-100" 
                v-model="username" 
                placeholder="Nom Utilisateur" 
                label="Filter par utilisateur"  
                :icon="require('@/assets/icons/search-w.svg')"
                @submit="fetchUsers"
              />

            </div>

            <div v-if="permissionsOptions && permissionsOptions.length" class="col-md-4 mb-2">
                <CustomInput
                  type="select"
                  v-model="selectedPermissions"
                  :options="permissionsOptions"
                  label="List des Permissions"
                  label-key="name"
                  placeholder="Choisir une Permission"
                />
            </div>

          </div>

          <div class="float-right mb-3"> 
            <b-button variant="outline-primary" size="sm" @click="addNewUser()">
              <span class="text-uppercase ">Ajouter Utilisateur</span>
            </b-button>
          </div>
          
          <UsersTable 
            :users="userList" 
            :loading="userListIsBusy"
            :page="mainPageModel.page" 
            :pageSize="mainPageModel.pageSize" 
            :total="mainPageModel.total"
            @update:page="onPageChange"
            @update:pageSize="onPageSizeChange"
            @update:data="onUpdatedRow"
            @update:row="onSelectedRow"
            @update:password="onchangePassword"
        
          />

      </div>
    </div>


   <!--MODALS--> 

    <b-modal
      v-if="showAddUserModal"
      v-model="showAddUserModal"
      hide-footer
      hide-header
      centered
      size="lg"
      modal-class="custom-banner-modal fancy-modal"
    >

      <!-- HEADER -->
      <div class="text-center mb-4">
        <h3 class="text-primary font-weight-bold text-uppercase">
          Ajouter un utilisateur
        </h3>
        <p class="text-muted" style="font-size: 14px;">
          Remplissez les informations nécessaires pour créer un nouveau compte.
        </p>
        <hr>
      </div>


        <div class="row mt-3">
          <div class="col-md-6 col-12">
            <b-form-checkbox v-model="user.isAdmin" switch>
              <div :class="user.isAdmin ? 'text-primary font-weight-bold' :'text-dark'" >Administrateur</div>
            </b-form-checkbox>
          </div>
          <div class="col-md-6 col-12">
            <b-form-checkbox v-model="user.isActive" switch class="mt-2">
              <div :class="user.isActive ? 'text-primary font-weight-bold' :'text-dark'" >Utilisateur actif</div>
            </b-form-checkbox>
          </div>
      </div>

      <div class="row mt-3">
        
        <div class="col-md-6">
          <CustomInput
            v-model="user.username"
            placeholder="Saisir nom utilisateur"
            label="Nom utilisateur"
            :showButton="false"
            class="mb-3"
          />
        </div>

        <div v-if="!this.editMode"  class="col-md-6">
          <CustomInput
            type="password"
            v-model="user.password"
            placeholder="Saisir mot de passe"
            label="Mot de passe"
            :showButton="false"
            class="mb-3"
          />
        </div>

        <div class="col-md-6">
          <CustomInput
            v-model="user.name"
            placeholder="Saisir nom et prénom"
            label="Nom & Prénom"
            :showButton="false"
            class="mb-3"
          />
        </div>

        <div class="col-md-6">
          <CustomInput
            v-model="user.email"
            placeholder="Saisir e-mail"
            label="E-mail"
            :showButton="false"
            class="mb-3"
          />
        </div>
      </div>


      <!-- FOOTER -->
      <div class="text-right mt-4">
        <b-button
          class="text-uppercase px-4"
          variant="primary"
          @click="saveNewUser"
        >
          <img
            src="@/assets/icons/save.svg"
            style="width: 18px; height: 18px; margin-right: 6px;"
            alt="Enregistrer"
          />
          Enregistrer
        </b-button>
      </div>

    </b-modal>


    <b-modal
      v-if="showChangePasswordModal"
      v-model="showChangePasswordModal"
      hide-footer
      hide-header
      centered
      size="lg"
      modal-class="custom-banner-modal fancy-modal"
    >

      <!-- HEADER -->
      <div class="text-center mb-4">
        <h3 class="text-primary font-weight-bold text-uppercase">
          Changer le mot de passe
        </h3>
        <p class="text-muted" style="font-size: 14px;">
          Vous modifiez le mot de passe de :
        </p>

        <!-- Name Display -->
        <div class="user-info-box">
          <strong class="text-dark" style="font-size: 17px;">
            {{ user.name }}
          </strong>
        </div>

        <hr>
      </div>

      <!-- FORM -->
      <div class="row">

        <div class="col-md-6">
          <CustomInput
            type="password"
            v-model="user.newPassword"
            placeholder="Nouveau mot de passe"
            label="Nouveau mot de passe"
            :showButton="false"
            class="mb-3"
          />
        </div>

        <div class="col-md-6">
          <CustomInput
            type="password"
            v-model="user.confirmPassword"
            placeholder="Confirmer le mot de passe"
            label="Confirmation"
            :showButton="false"
            class="mb-3"
          />
        </div>

      </div>

      <!-- FOOTER -->
      <div class="text-right mt-4">
        <b-button
          class="text-uppercase px-4"
          variant="primary"
          @click="savePassword"
        >
          <img
            src="@/assets/icons/save.svg"
            style="width: 18px; height: 18px; margin-right: 6px;"
            alt="Enregistrer"
          />
          Enregistrer
        </b-button>
      </div>

    </b-modal>



    </div>
  </Layout>
</template>


<style scoped>
.custom-card-description {
  max-width: 80%;
  margin: auto;
  background-color: #ffffff;
  color: #444;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  letter-spacing: 1.1px;
  text-align: justify; 
}

@media (max-width: 640px) {
  .custom-card-description {
    max-width: 90%;
  }
}

.custom-card-description:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.custom-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.custom-card h2 {
  font-size: 1.8rem;
  color: #444;
  font-weight: 600;
}

</style>


<style>

.fancy-modal {
  border-radius: 14px !important;
}

.fancy-modal .modal-content {
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
}


.user-info-box {
  background: #f8f9fa;
  padding: 10px 15px;
  border-radius: 8px;
  display: inline-block;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}


</style>